import { useMemo } from 'react';
import type { DisplayOptions } from '@/core/theory/display';
import { usePlayerStore } from './playerStore';
import { useSettingsStore } from './settingsStore';

/** Everything that decides how chord names read: song key, transpose, capo, notation, spelling. */
export function useDisplayOptions(): DisplayOptions | null {
  const key = usePlayerStore((s) => s.result?.key);
  const transpose = usePlayerStore((s) => s.transpose);
  const capo = usePlayerStore((s) => s.capo);
  const notation = useSettingsStore((s) => s.notation);
  const accidentals = useSettingsStore((s) => s.accidentals);
  return useMemo(
    () => (key ? { key, transpose, capo, notation, accidentals } : null),
    [key, transpose, capo, notation, accidentals],
  );
}
